import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";

const css = assetUrl("../../styles/checkComponent.css");
const tick = assetUrl("../../assets/icons/white-tick.svg");

const CheckComponent = ({ title, id, checked, onChange }) => {
  return (
    <>
      <Helmet>
        <link rel="stylesheet" href={css} />
      </Helmet>
      <label
        className={`check-container ${checked ? "checked" : ""}`}
        htmlFor={id}
      >
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={onChange}
          className="check-input"
        />
        <div className="check-icon">
          {checked && <img src={tick} alt="tick" />}
        </div>
        <h5 className="check-label">{title}</h5>
      </label>
    </>
  );
};

CheckComponent.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CheckComponent;
